window._ = require('lodash');

try {
    require('bootstrap');
    
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import Echo from 'laravel-echo';

const api_key =  process.env.MIX_SOCKET_API_KEY;
const auth_url =  process.env.MIX_SOCKET_AUTH_URL;

console.log(api_key , auth_url);

window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: false,
    disableStats: true,
    cluster: 'mt1',
    enabledTransports: ['ws', 'wss'],
    namespace : null,
    authorizer: (channel, options) => {
        return {
            authorize: (socketId, callback) => {
                // Create the authentication payload with socket ID , channel name , user id and user name
                const authPayload = {
                    socket_id: socketId,
                    channel_name: channel.name,
                    user_id: window.user_id,
                    user_name: window.user_name
                };

                // Send the authorization request to the Laravel Socket server
                window.axios.post(auth_url ,authPayload , {
                        headers: {
                            'Authorization':  `Bearer ${api_key}`,
                            'X-Requested-With': 'XMLHttpRequest',
                        }
                    }).then(response => {
                        // Pass the response data to Echo to complete the authentication
                        callback(false, response.data);
                    })
                    .catch(error => {
                        console.error('Authorization error:', error);
                        callback(true, error);
                    });
            }
        };
    }
});


